import { useEffect, useState } from 'react';
import { gtagAPI } from '../services/api';

const GtagInjector = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!loaded) {
      fetchAndInjectGtag();
    }
  }, [loaded]);

  const fetchAndInjectGtag = async () => {
    try {
      const response = await gtagAPI.getCode();
      
      if (response.data.enabled && response.data.gtag_code) {
        console.log('✅ Gtag enabled, injecting code...');
        
        // Remove existing gtag scripts if any
        const existingScripts = document.querySelectorAll('script[data-gtag="true"]');
        existingScripts.forEach(script => script.remove());
        
        // Parse and inject the gtag code
        const gtagCode = response.data.gtag_code;
        
        // Extract script content and src from the gtag code
        const scriptRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
        let match;
        
        while ((match = scriptRegex.exec(gtagCode)) !== null) {
          const scriptTag = match[0];
          const scriptContent = match[1];
          
          // Check if it's an external script (has src attribute)
          const srcMatch = scriptTag.match(/src=["']([^"']+)["']/);
          
          if (srcMatch) {
            // External script
            const script = document.createElement('script');
            script.async = true;
            script.src = srcMatch[1];
            script.setAttribute('data-gtag', 'true');
            document.head.appendChild(script);
            console.log('✅ Injected external gtag script:', srcMatch[1]);
          } else if (scriptContent.trim()) {
            // Inline script
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.textContent = scriptContent;
            script.setAttribute('data-gtag', 'true');
            document.head.appendChild(script);
            console.log('✅ Injected inline gtag script');
          }
        }
        
        setLoaded(true);
      } else {
        console.log('ℹ️ Gtag not enabled or no code provided');
      }
    } catch (error) {
      console.error('❌ Error fetching gtag code:', error);
    }
  };

  // This component doesn't render anything
  return null;
};

export default GtagInjector;
